export default __webpack_public_path__ + "static/media/player-katie-colour-desk.ec1d0feb.png";